module.exports = __webpack_public_path__ + "static/EGR_FlashPage_1-5b3af5d1f463e415047e0df90c6256e9.jpg";